import axios from 'axios';
import {
  Toast
} from 'vant';
import qs from 'qs';
import {
  MAP_LIST
} from './ajaxMap';
import md5 from 'js-md5';
import ajaxNet from "./ajaxGateWay";

const ESB_DEV_URL = 'http://' + window.location.host; //开发使用地址
const API_DEV_URL = 'http://' + window.location.host; //开发使用地址
const ESB_URL = 'http://122.228.182.58:8090';
// const API_URL = "http://114.215.211.66:8382"; //用户登录等接口 阿里云测试
const API_URL = 'http://122.228.182.58:8382'; // 用户登录等接口 http://122.228.182.58:8382/swagger-ui.html
// 浙里办APP龙湾医疗健康   接入码：lwyljk    接入密码：lwyljkpwd
// let BASE_URL = process.env.NODE_ENV === 'development' ? DEV_URL : PRO_URL;
const isDevelopment = process.env.NODE_ENV === 'development';
let BASE_URL;

export default function ajax(params) {
  let method = params.method || 'post';
  // let contentType = params.contentType || 'text/xml; charset=utf-8';
  let transNO = params.transNO || ''; //交易号
  let tempParams = params.params;


  let restfulURL = MAP_LIST[transNO] || '';
  let header={};
  let finalParams;
  let axiosParams;
  let requestUrl;

  if (transNO == 'zjzw') {
    BASE_URL = 'http://122.228.182.58:8097/pjrz?st=' + tempParams.st;
  } else {
    //esb请求
    if (!restfulURL) {
      return ajaxNet(params)
      BASE_URL = '';
      requestUrl = '/CsbBusService.asmx/ProcessJson';
      tempParams.trans_no = transNO;
      let xmlString = {
        Json: JSON.stringify({
          body: {
            head: {
              trans_no: transNO,
              timestamp: (new Date()).getTime(),
              userid: 'wxgzh',
              password: 'wxgzh',
            },
            resquest: tempParams
          }
        })
      };
      finalParams = qs.stringify(xmlString)
    } else {
      //api请求
      BASE_URL = '';
      requestUrl = restfulURL;
      finalParams = qs.stringify(tempParams);
      if (method === 'get') {
        axiosParams = {
          userId: common.getSession('userId')
        };
      }
      // if (common.getSession('token') != null || common.getSession('userId') != null) {
      // header = {
      //     Authorization: common.getSession('token'),
      //     CURRENT_USER_ID: common.getSession('userId')
      //   }
      // }
      if (common.getStorage('token') != null || common.getStorage('userId') != null) {
        header = {
          Authorization: common.getStorage('token'),
          CURRENT_USER_ID: common.getStorage('userId')
        }
      }
      // if (transNO === 'login' || transNO === 'getSecurityCode') {
      //   header = null;
      // }
      let timestamp1 = new Date().getTime()
      const appid = 'jtpt03'
      const appSecret = 'LinghuSMS3_'
      const nonce = md5(timestamp1.toString())
      header['userapi-validate-appid'] = appid
      header['userapi-validate-timestamp'] = timestamp1
      header['userapi-validate-nonce'] = nonce
      header['userapi-validate-signature'] = md5('appid=' + appid + 'appsecret=' + appSecret + 'nonce=' + nonce + 'timestamp=' + timestamp1.toString())
    }
  }


  header = header || {
    'Content-Type': 'application/x-www-form-urlencoded'
  };

  if (params.isLoading !== false) {
    Toast.loading({
      message: '请稍等',
      duration: 0,
      forbidClick: true
    });
  }
  return new Promise((resolve, reject) => {
    // axios.post(BASE_URL, finalParams, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {

    axios({
        baseURL: BASE_URL,
        url: requestUrl,
        headers: header,
        method: method,
        timeout: 20000,
        data: finalParams,
        params: axiosParams || null
      })
      .then((res) => {

        if (params.closeLoading !== true) {
          Toast.clear();
        }
        if (!restfulURL) {
          let tempRes = res.data.replace('<?xml version="1.0" encoding="utf-8"?>', '')
            .replace('<string xmlns="http://tempuri.org/">', '')
            .replace('<string xmlns="http://tempuri.org/" />', '')
            .replace('</string>', '');
          let body = JSON.parse(tempRes);
          let response = body.body.response;
          // console.log(response)
          // 根据结果进行返回
          if (Number(response.ret_code) === 0) {
            resolve(response);
          } else {
            if (!params.toast) Toast.fail(response.ret_info);
            reject(response);
          }
        } else {
          //api特殊处理
          let response = res.data;
          if (Number(response.code) === 200) {
            resolve(response);
          } else {
            if (!params.toast) Toast.fail(response.message);
            reject(response);
          }
        }
      }).catch((error) => {
        Toast.clear();
        // console.log(error.message);
        reject(error);
      });
  })
}



//////////////////
// WEBPACK FOOTER
// ./static/js/ajax.js
// module id = null
// module chunks = 